import type { QuizAttemptPublic } from '@repo/types/quiz';

import type { BadgeProps } from '@/components/ui/badge';

export type AttemptStatus = 'in-progress' | 'unmarked' | 'graded';

export const STATUS_BADGE_META: Record<AttemptStatus, { label: string; variant: BadgeProps['variant'] }> = {
  'in-progress': { label: 'W trakcie', variant: 'warning' },
  unmarked: { label: 'Nieocenione', variant: 'destructive' },
  graded: { label: 'Ocenione', variant: 'success' },
};

export const STATUS_FILTER_OPTIONS = [
  { value: 'in-progress', label: STATUS_BADGE_META['in-progress'].label },
  { value: 'unmarked', label: STATUS_BADGE_META.unmarked.label },
  { value: 'graded', label: STATUS_BADGE_META.graded.label },
] satisfies { label: string; value: AttemptStatus }[];

/**
 * Determines the status of a quiz attempt based on completion and scoring
 * @param attempt - The quiz attempt to evaluate
 * @returns The status badge type
 */
export function getAttemptStatus(attempt: QuizAttemptPublic): AttemptStatus {
  if (attempt.completed === false) {
    return 'in-progress';
  }
  if (attempt.score == undefined || attempt.score == null) {
    return 'unmarked';
  }
  return 'graded';
}

/**
 * Gets the badge metadata for an attempt status
 * @param status - The attempt status
 * @returns Object with label and variant for Badge component
 */
export function getAttemptStatusBadgeMeta(status: AttemptStatus) {
  return STATUS_BADGE_META[status];
}

/**
 * Gets the badge metadata directly from an attempt
 * @param attempt - The quiz attempt
 * @returns Object with label and variant for Badge component
 */
export function getAttemptBadgeMeta(attempt: QuizAttemptPublic) {
  const status = getAttemptStatus(attempt);
  return getAttemptStatusBadgeMeta(status);
}
